module.exports = __webpack_public_path__ + "static/media/exchange-flat.36e8f82d.png";